import React from "react";
import { withRouter } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import ListItemText from "@material-ui/core/ListItemText";
import UserIcon from "@material-ui/icons/Person";
import DoneIcon from "@material-ui/icons/Done";
import EventIcon from "@material-ui/icons/Event";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import GetAppIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DeleteIcon from "@material-ui/icons/Delete";
import ClassIcon from "@material-ui/icons/Class";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import constants from "../../../tools/constants";
import withContext from "../../../tools/withContext";
import generateType from "./generateType";
import requestFileDownload from "./requestDownloadFile";
import { BATCH_STATUS } from "./FilteringBatchesDialog";
import BatchType from "../../../types/Batch";
import { isBatchReadOnly } from "../../../tools/isBatchReadOnly";
import { canLabelizeBatch } from "../../homepage/widgets/utils";

//@ts-ignore
const backHost = `${process.env.REACT_APP_API_URL}`;

export interface BatchMenuHandlers {
  closeMenu: () => void;
  openDialog: (view: "attrib" | "deadline" | "applyLabeling") => void;
  openAlert: (message: any) => void;
  pushToHistory: (batchId: number) => void;
  history: { push: (path: string) => void };
  token: string;
}

export const buildBatchMenuOptions = (
  batch: BatchType,
  handlers: BatchMenuHandlers,
  userRole: string
) => {
  const { closeMenu, openDialog, openAlert, pushToHistory, history, token } =
    handlers;

  const isAdminRole =
    userRole === "ROLE_ADMIN" || userRole === "ROLE_PROJECT_ADMIN";
  const type = generateType(batch);

  return [
    {
      label: "Exporter vers csv",
      component: "span",
      href: null,
      roles: ["ROLE_ADMIN"],
      isVisible: () => true,
      onClick: async () => {
        await requestFileDownload(
          "GET",
          `${backHost}${constants.paths.BATCHES_EXPORT_PATH}?type=CSV&batches=${batch.id}`,
          token,
          "",
          "application/json"
        );
        closeMenu();
      },
      icon: <GetAppIcon />,
    },
    {
      label: "Exporter vers json",
      component: "span",
      href: null,
      roles: ["ROLE_ADMIN"],
      isVisible: () => true,
      onClick: async () => {
        await requestFileDownload(
          "GET",
          `${backHost}${constants.paths.BATCHES_EXPORT_PATH}?type=JSON&batches=${batch.id}`,
          token,
          "",
          "application/json"
        );

        closeMenu();
      },
      icon: <GetAppIcon />,
    },
    {
      label: "Appliquer une labellisation",
      href: null,
      component: "span",
      roles: ["ROLE_ADMIN"],
      isVisible: () => true,
      onClick: (e: any) => {
        e.stopPropagation();
        openDialog("applyLabeling");
        closeMenu();
      },
      icon: <CloudUploadIcon />,
    },
    {
      label: "Labelliser",
      href: null,
      component: "span",
      roles: ["ROLE_LABELER", "ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () => canLabelizeBatch(batch, userRole),
      onClick: (e: any) => {
        e.stopPropagation();        
        const lastLabeledImage =
          batch.totalLabelDocs < batch.totalEligibleDocs
            ? batch.totalLabelDocs
            : 0;
        pushToHistory(batch.id);
        window.open(`/labeler${type}/${batch.id}/${lastLabeledImage}`, "_blank");
        closeMenu();
      },
      icon: <ClassIcon />,
    },
    {
      label: "Reprendre du début",
      href: null,
      component: "span",
      roles: ["ROLE_LABELER", "ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () =>
        batch.state === BATCH_STATUS.IN_PROGRESS.name ||
        batch.state === BATCH_STATUS.TO_BE_CORRECTED.name ||
        (isAdminRole && batch.state === BATCH_STATUS.COMPLETED.name),
      onClick: (e: any) => {
        e.stopPropagation();        
        pushToHistory(batch.id);
        window.open(`/labeler${type}/${batch.id}/0`, "_blank");
        closeMenu();
      },
      icon: <FirstPageIcon />,
    },
    {
      label: "Voir le lot",
      href: null,
      component: "span",
      roles: ["ROLE_LABELER", "ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () =>
        isBatchReadOnly(batch.state),
      onClick: (e: any) => {
        e.stopPropagation();        
        pushToHistory(batch.id);
        window.open(`/labeler${type}/${batch.id}/0`, "_blank");
        closeMenu();
      },
      icon: <VisibilityIcon />,
    },
    {
      label: "Modifier l'attribution",
      href: null,
      component: "span",
      roles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () => true,
      onClick: (e: any) => {
        e.stopPropagation();
        openDialog("attrib");
        closeMenu();
      },
      icon: <UserIcon />,
    },
    {
      label: "Date limite",
      href: null,
      component: "span",
      roles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () => true,
      onClick: (e: any) => {
        e.stopPropagation();
        openDialog("deadline");
        closeMenu();
      },
      icon: <EventIcon />,
    },
    {
      label: "Mosaique",
      href: null,
      component: "span",
      roles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () => false, //batch.filterFields.percentDone === 100,
      onClick: (e: any) => {
        e.stopPropagation();
        pushToHistory(batch.id);
        history.push(`/mosaic/${batch.id}`);
      },
      icon: <DashboardIcon />,
    },
    {
      label: "Lot terminé",
      href: null,
      component: "span",
      roles: ["ROLE_LABELER", "ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
      isVisible: () =>
        batch.totalLabelDocs === batch.totalEligibleDocs &&
        (batch.state === BATCH_STATUS.IN_PROGRESS.name ||
          batch.state === BATCH_STATUS.TO_BE_CORRECTED.name),
      onClick: (e: any) => {
        e.stopPropagation();
        openAlert({
          type: BATCH_STATUS.COMPLETED.name,
          title: "Lot terminé",
          text: `Voulez-vous marquer ce lot comme terminé ?`,
        });
        closeMenu();
      },
      icon: <DoneIcon />,
    },
    {
      label: "Lot à corriger",
      href: null,
      component: "span",
      roles: ["ROLE_LABELER", "ROLE_ADMIN"],
      isVisible: () =>
        batch.totalLabelDocs === batch.totalEligibleDocs &&
        batch.state === BATCH_STATUS.COMPLETED.name,
      onClick: (e: any) => {
        e.stopPropagation();
        openAlert({
          type: BATCH_STATUS.TO_BE_CORRECTED.name,
          title: "Lot à corriger",
          text: `Voulez-vous rouvrir ce lot pour effectuer des modifications ?`,
        });
        closeMenu();
      },
      icon: <RefreshIcon />,
    },
    {
      label: "Lot vérifié",
      href: null,
      component: "span",
      roles: ["ROLE_ADMIN"],
      isVisible: () =>
        batch.totalLabelDocs === batch.totalEligibleDocs &&
        batch.state === BATCH_STATUS.COMPLETED.name,
      onClick: (e: any) => {
        e.stopPropagation();
        openAlert({
          type: BATCH_STATUS.VERIFIED.name,
          title: "Lot vérifié",
          text: `Voulez-vous valider définitivement ce lot ? Il sera marqué comme vérifié (état final).`,
        });
        closeMenu();
      },
      icon: <DoneAllIcon />,
    },
    {
      label: "Supprimer le lot",
      href: null,
      component: "span",
      roles: ["ROLE_ADMIN"],
      isVisible: () => true,
      onClick: (e: any) => {
        e.stopPropagation();
        openAlert({
          type: "DELETE",
          title: "Supprimer un lot",
          text: `Voulez-vous vraiment supprimer le lot ${batch.name} ?`,
        });
        closeMenu();
      },
      icon: <DeleteIcon />,
    },
  ];
};

export const getVisibleBatchMenuItems = (
  batch: BatchType,
  userRole: string,
  handlers: BatchMenuHandlers
) =>
  buildBatchMenuOptions(batch, handlers, userRole).filter(
    (option) => option.roles.includes(userRole) && option.isVisible()
  );

const BatchActionsMenu = (props: any) => {
  const {
    closeMenu,
    pushToHistory,
    history,
    anchorEl,
    batch,
    openDialog,
    openAlert,
    ctx: {
      user: { token },
    },
  } = props;

  const menuItems = getVisibleBatchMenuItems(batch, props.userRole, {
    closeMenu,
    openDialog,
    openAlert,
    pushToHistory,
    history,
    token,
  });

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <Menu
      id="lock-menu"
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      open={Boolean(anchorEl)}
      disableAutoFocusItem
      onClose={closeMenu}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
    >
      {menuItems.map((option: any, index: any) => (
        <MenuItem
          dense
          component={option.component}
          key={index}
          onClick={option.onClick}
          href={option.href}
        >
          <ListItemIcon>{option.icon}</ListItemIcon>
          <ListItemText>{option.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default withRouter(withContext(BatchActionsMenu));
